import React, { useEffect, useState, useLayoutEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useLocaleContext } from '../../context/LocaleContext';
import { ScheduleContextProvider } from '../../context/ScheduleContext';
import { ModalContextProvider } from '../../context/ModalContext';
import { PAGES_VIEW_GRID } from '../../constants/page-settings/schedule';
import { capitalizer } from "../../../../cp/utils";
import PageContainer from "../../components/PageContainer";
import Schedule from '../../components/Schedule';
import ScheduleFilters from '../../components/Schedule/ScheduleFilters';
import { CButton } from '../../components/UI';
import SchedulePdf from '../../components/Pdf/Schedule';
import { usePdf } from '../../hooks/usePdf';
import { useWidgetContext } from "../../context/WidgetContextProvider";

import './style.scss';

export default ({ event, page, children }) => {
    const $locale = useLocaleContext();
    const params = useParams();
    const { isWidget } = useWidgetContext();
    const { target, savePdf, pdfSettings } = usePdf({
        locale: $locale.name,
        eventKey: event.eventKey,
    });
    const location = useLocation();
    const navigate = useNavigate();
    const paramsLocation = new URLSearchParams(location.search);
    const tabActive = paramsLocation.get('tab-active');
    const [isActiveFavorites, setIsActiveFavorites] = useState(false);

    useEffect(() => {
        addPageStyles();
    }, [params]);

    useLayoutEffect(() => {
        setIsActiveFavorites(tabActive === "favorites");
    }, [tabActive]);

    function addPageStyles() {
        const schedulePage = document.querySelector('.program-page-root');

        if (!schedulePage) return;

        schedulePage.style.backgroundImage = `url(${page.settings.backgroundUrl})`;

        page?.settings?.backgroundFixed
            ? schedulePage.classList.add('program-page-root--background-fixed')
            : schedulePage.classList.remove('program-page-root--background-fixed')
    }

    const isBookmarkVisible = !isWidget && event?.moduleEpisode?.episodeFavorite;

    return (
        <PageContainer>
            <section className={`schedule-page ${!!page.settings.backgroundUrl ? 'page-section-background' : ''} ${page?.settings.showSubstrate ? 'page-section-background--filled' : ''}`}>
                {/* Скрыто т.к. пока не используется */}
                {/* <BroadcastInfoBar /> */}
                <div className="schedule-page-programs">
                    <div className="schedule-page-programs__header">
                        <div className="schedule-page-programs__header-tabs">
                            {page.settings.showTitle && (
                                <h1
                                    onClick={() => navigate(`${location.pathname}`)}
                                    className={`schedule-page-programs__header-title ${isBookmarkVisible ? 'selectable' : ''} ${!isActiveFavorites ? '-active' : ''}`}
                                >
                                    {page.settings ? page.settings[`title${capitalizer($locale.name)}`] : $locale.get('title.page.program')}
                                </h1>
                            )}
                            {
                                isBookmarkVisible &&
                                <h1
                                    onClick={() => navigate(`${location.pathname}?tab-active=favorites`)}
                                    className={`schedule-page-programs__header-title selectable ${isActiveFavorites ? '-active' : ''}`}
                                >
                                    {$locale.get('title.favorites')}
                                </h1>
                            }
                        </div>
                        {!isActiveFavorites && (
                            <div
                                className="schedule-page-programs__header-actions"
                            >
                                {/* <CButton
                                    label={$locale.get('label.favorite.view')}
                                    icon="bookmark"
                                /> */}
                                {
                                    (page?.settings?.showAddToCalendar ?? true) &&
                                    <CButton
                                        label={$locale.get('label.calendar.add')}
                                        icon="calendar"
                                        iconStyles="calendar"
                                        onClick={() => window.open(`/api/player/event/${event.eventKey}/calendar.ics?locale=${$locale.name}&hideAddress=true`, '_blank')}
                                    />
                                }
                                {
                                    event.moduleEpisode.pdfExportEnabled &&
                                    <CButton
                                        label={$locale.get('label.pdf.download')}
                                        icon="download"
                                        theme="accent"
                                        className="pdf-btn"
                                        onClick={savePdf}
                                    />
                                }
                            </div>
                        )}
                    </div>
                    <div className="schedule-page-programs__view">
                        <ScheduleContextProvider
                            event={event}
                            page={page}
                            pdfSettings={event.moduleEpisode.pdfExportEnabled ? pdfSettings : null}
                        >
                            <ModalContextProvider showModals={!!page?.settings ? page.settings.showModals : true}>
                                {!isActiveFavorites && (
                                    <ScheduleFilters
                                        viewsList={page?.settings.scheduleViews}
                                        hasFormatFilter={page?.settings?.showFormats}
                                    />
                                )}
                                <Schedule isActiveFavorites={isActiveFavorites} />
                            </ModalContextProvider>
                            {
                                event.moduleEpisode.pdfExportEnabled &&
                                <SchedulePdf
                                    ref={target}
                                    type={PAGES_VIEW_GRID}
                                    event={event}
                                    pdfSettings={pdfSettings}
                                />
                            }
                        </ScheduleContextProvider>
                    </div>
                </div>
                {children}
            </section>
        </PageContainer>
    );
}
